import React from 'react'
import { Row, Col } from 'rsuite'
import { getValueFromOptions } from '../../utils/dataUtil'
import ScrutinizeAttachFiles from './ScrutinizeAttachFiles'

export default function ScrutinizeMethodView({ schema, onDownload, onPreview, isMeetingResult }) {
  const noData = '- ไม่ระบุ -'

  return (
    <>
      <Row style={{ marginLeft: 20 }}>
        {!isMeetingResult && (
          <Col>
            <p>
              {getValueFromOptions(
                schema.scrutinizeMethod.options,
                schema.scrutinizeMethod.value
              ) || noData}
            </p>
            <br />
          </Col>
        )}

        {schema?.scrutinizeMethod?.value == '2' && (
          <>
            <Col>
              <p>
                {schema.meettingName.label} : {schema.meettingName.value || noData}
              </p>
              <p>
                {schema.meettingDate.label} : {schema.meettingDate.value || noData}
              </p>
            </Col>
            <Col>
              <p style={{ marginTop: 10 }}>{schema.attachFiles.label}</p>
              <ScrutinizeAttachFiles
                data={schema.attachFiles?.values || []}
                onDownload={onDownload}
                onPreview={onPreview}
                isEdit={false}
              ></ScrutinizeAttachFiles>
            </Col>
          </>
        )}
      </Row>
    </>
  )
}
